import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle';
import { Provider } from 'react-redux';
import store from "./store";
import 'bootstrap/dist/css/bootstrap.css'

import {
  QueryClient,
  QueryClientProvider
} from '@tanstack/react-query';

const root = ReactDOM.createRoot(document.getElementById('root'));
const queryClient = new QueryClient();
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
      <Provider store={store}>
     <App />
     </Provider>
      </QueryClientProvider>
      </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
